



















































import {Component, Watch} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import AuthMixin from "../../mixins/auth.mixin";
import {IMaterial, MaterialType} from "shared/entities/material";
import {Api} from "shared/api";
import {apiHandler} from "@/services/api-handler";

@Component({})
export default class ManageMaterials extends mixins(AuthMixin) {
    MaterialType = MaterialType;
    materials: IMaterial[] = [];

    orderedMaterials: Record<number, IMaterial[]> = {};
    materialOrders: number[] = [];

    get maxOrder() {
        return this.materialOrders.reduce((p, n) => Math.max(p, n), 0);
    }

    async mounted() {
        await this.loadMaterials();
    }

    @Watch("materials", {deep: true})
    private onMaterialsChanged() {
        this.materialOrders = this.materials.map(m => m.order).filter((o, i, a) => a.indexOf(o) === i).sort();

        this.orderedMaterials = {};
        for (const order of this.materialOrders) this.orderedMaterials[order] = [];
        for (const material of this.materials) this.orderedMaterials[material.order].push(material);
    }

    private async loadMaterials() {
        this.materials = await apiHandler(() => Api.material.Get());
    }

    async remove(material: IMaterial) {
        if (!confirm(`Are you sure you want to remove ${material.title}`)) {
            return;
        }
        await Api.material[material.id].Delete();
        alert("Material has been removed.");
        await this.loadMaterials();
    }

    canDecrease(material: IMaterial) {
        return material.order > 1;
    }

    canIncrease(material: IMaterial) {
        return material.order < this.maxOrder ||
            this.orderedMaterials[material.order].length > 1;
    }

    async decreaseOrder(material: IMaterial) {
        if (!this.canDecrease(material)) return;

        if (this.orderedMaterials[material.order].length === 1) {
            for (let i = material.order + 1; i <= this.maxOrder; i++) {
                if (this.orderedMaterials[i]) {
                    await this.changeMaterialOrder(this.orderedMaterials[i], i - 1);
                }
            }
            await this.changeMaterialOrder(material, material.order - 1);
        } else {
            for (let i = this.maxOrder; i <= material.order; i++) {
                if (this.orderedMaterials[i]) {
                    await this.changeMaterialOrder(this.orderedMaterials[i].filter(m => m.id !== material.id), i + 1);
                }
            }
        }
    }

    async increaseOrder(material: IMaterial) {
        if (!this.canIncrease(material)) return;

        if (this.orderedMaterials[material.order].length === 1) {
            for (let i = material.order + 1; i <= this.maxOrder; i++) {
                await this.changeMaterialOrder(this.orderedMaterials[i], i - 1);
            }
        } else {
            for (let i = this.maxOrder; i >= material.order + 1; i--) {
                if (this.orderedMaterials[i])
                    await this.changeMaterialOrder(this.orderedMaterials[i], i + 1);
            }
            await this.changeMaterialOrder(material, material.order + 1);
        }

    }

    async changeMaterialOrder(material: IMaterial | IMaterial[], order: number) {
        if (!Array.isArray(material)) material = [material];
        for (const m of material)
        {
            await apiHandler(() => Api.material[m.id].Patch({order}));
            m.order = order;
        }
    }

}

